// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_gb-2";
export var aiChatCartContainerExit = "_gb-4";
export var aiChatContainerLarge = "_gb-0";
export var aiChatContainerSmall = "_gb-1";
export var aiChatIcon = "_gb-6";
export var slideInFromRight = "_gb-3";
export var slideOutToRight = "_gb-5";